import type { ReactNode } from 'react';

/**
 * 攤開式卡殼（取代 CollapsibleSection 的收合外殼）。
 *
 * 企鵝雪屋密排版面原則：標題列 .card-h（標題 + 右側 tag / 操作），
 * 內容「常態攤開、不收合」—— 收合只是治標，會把有用資訊藏起來要點開才看到。
 * 次級資訊請在 children 內用「卡內 tab」或「展開全部」壓縮，而不是把整張卡收起來。
 */
export function PanelCard({
  title,
  tag,
  actions,
  children,
  className,
  bodyClassName,
}: {
  title: ReactNode;
  /** 標題右側的小灰標籤（mockup .tag）。 */
  tag?: ReactNode;
  /** 標題最右側的操作元素（按鈕 / 切換）。 */
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}) {
  return (
    <section className={`card flex flex-col${className ? ` ${className}` : ''}`}>
      <div className="card-h">
        <h2>{title}</h2>
        {(tag || actions) && (
          <div className="card-h-r">
            {tag && <span className="tag">{tag}</span>}
            {actions}
          </div>
        )}
      </div>
      <div className={`flex-1${bodyClassName ? ` ${bodyClassName}` : ''}`}>{children}</div>
    </section>
  );
}
